export const CLASS_API_ROUTES = {
  GET_CLASS: "admin/classes",
  GET_CLASS_BY_ID: "admin/classes/:id",
  CREATE_CLASS: "admin/classes",
  UPDATE_CLASS: "admin/classes/:id",
  DELETE_CLASS: "admin/classes/:id",
};
